import m from "mithril";
import h from "../../../ui/design";
import ICustomFormSettings from "../../ICustomFormSettings";
import Upload from "../Upload";
import Uploader from "../Uploader";
import MessageBox from "../../shared/components/MessageBox/MessageBox";
import {CheckboxItem} from "../../../model/items/checkbox";

export default class UploadPhotos extends Upload
{
    private readonly uploader: Uploader;
    private readonly successMessage: MessageBox;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.uploader = new Uploader(
            this.filesMetadata,
            'image',
            this.filesCount,
        );

        this.successMessage = new MessageBox(
            this.settings.form.questionary,
            "fileUploaded",
            "success",
            "success"
        );
    }

    public view() {
        const showMessage = this.filesMetadata.getVariable() && !this.uploader.fileCount() && !this.uploader.getIsUploading();

        return this.viewLayout([
            m("form", {}, [
                showMessage ? m(this.successMessage) : null,
                m(this.uploader),
                m('.globalUnknown', {}, this.checkboxes.map(cell => m(cell))),
            ]),
        ]);
    }


    private showDefaultControls(): boolean {
        if (this.filesMetadata.getVariable() && !this.uploader.fileCount()) {
            return true; // Files are uploaded, ready to next form
        }
        if (this.checkboxes[0] && this.checkboxes[0].cell.cellItems[0]) {
            const checkbox: CheckboxItem = <CheckboxItem>this.checkboxes[0].cell.cellItems[0];
            return checkbox.globalUnknown && checkbox.variable && checkbox.variable(); // Global unknown check
        }
        return false;
    }

    protected viewControls(nextButtonText: string = 'nextButton') {
        if (this.showDefaultControls()) {
            return super.viewControls(nextButtonText);
        }

        const form = this.settings.form;
        const questionary = form.questionary;
        const visiblePreviousButton = this.settings.app.prevEnabled();
        const disabled = !this.uploader.fileCount();

        return m(".controls", {},
            m(".control-group", {}, [
                visiblePreviousButton ? m("button.btn.large.outline.secondary#previousButton", {
                    onclick: () => this.settings.prevForm(),
                    title: questionary.renderText(questionary.messages.get('backButton')),
                }, [
                    m('i.icon.icon-chevron-left', {}, '')
                ]) : null,

                m("button.btn.large.raised.primary"+(disabled ? h.backgroundDisabled : h.backgroundPrimary)+"#nextButton", {
                    disabled: disabled ? 'disabled' : false,
                    onclick: (e: MouseEvent) => {
                        e.preventDefault();
                        this.uploader.uploadFiles();
                    },
                }, [
                    m('span', {}, questionary.renderText(questionary.messages.get('upload')) ),
                    m('i.icon.icon-chevron-right.text-light', {}, '')
                ]),
            ])
        );
    }

    onupdate() {
        // There is any active unknown
        if (this.settings.form.activeGlobalUnknown) {
            const needRedraw = this.uploader.fileCount();
            this.uploader.reset();
            if (needRedraw) {
                m.redraw();
            }
        }
    }
}